import React from "react";
import FullPageLoader from "../../../component/shared/FullPageLoader";
// import { getPageLoader } from "../../selectors/pageLoader.selector";
import { useSelector } from "react-redux";
import { getPageLoader } from "../../selector/pageLoader.selector";

const GlobalPageLoader = () => {
  const pageLoader = useSelector(getPageLoader);

  return [pageLoader ? <FullPageLoader /> : null];
};

export default GlobalPageLoader;
